import request from '@/axios/index.js'
const uri = '/user/gold/grt/';
export function guaranteeLawTxtAPI(data, loading) {// 拒绝, 保证
    return request.axios({
        loading: loading,
        data: data,
        url: uri + 'getGuaranteeLawTxt'
    })
}
export function doSaveGuaranteeListAPI(data, loading) {// 应付祺信-申请保证
    return request.axios({
        loading: loading,
        data: data,
        url: uri + 'doSaveGuaranteeList'
    })
}
export function refusedGuaranteeAPI(data, loading) {// 拒绝, 保证
    return request.axios({
        loading: loading,
        data: data,
        url: uri + 'doGuaranteeList'
    })
}
export function doSaveGuaranteeApi(data, loading) {//开立确认密码
    return request.axios({
        loading: loading,
        data: data,
        url: uri + 'doSaveGuarantee'
    })
}
export function doSaveGuaranteeV2(data, loading) {//开立确认密码
    return request.axios({
        loading: loading,
        data: data,
        url: uri + 'doSaveGuaranteeV2'
    })
}


// WEBPACK FOOTER //
// ./src/api/guarantee.js